<div class="merge-section">
    <div class="section-content" [ngClass]="{ 'no-record-selected': noRecordSelected }">
        <div *ngIf="noRecordSelected" class="no-record-message">
            <i class="material-icons">info</i>
            <p>Select a master record to view merge data</p>
        </div>

        <div *ngIf="!noRecordSelected && isExpanded" class="grid-container">
            <td-grid
                *ngIf="mergeGridOptions && mergeData.length > 0"
                [gridOptions]="mergeGridOptions"
                [columnDefs]="mergeGridOptions.columnDefs"
                [defaultColDef]="mergeGridOptions.defaultColDef"
                [rowSelection]="mergeGridOptions.rowSelection"
                [rowMultiSelectWithClick]="mergeGridOptions.rowMultiSelectWithClick"
                [suppressNoRowsOverlay]="mergeGridOptions.suppressNoRowsOverlay"
                [pagination]="mergeGridOptions.pagination"
                [paginationPageSize]="mergeGridOptions.paginationPageSize"
                [paginationPageSizeSelector]="mergeGridOptions.paginationPageSizeSelector"
                [localeText]="mergeGridOptions.localeText"
                (gridReady)="onMergeGridReady($event)"
                (rowSelected)="onMergeRowSelect($event)"
            ></td-grid>
            <div *ngIf="mergeData.length === 0" class="no-data-message">
                <i class="material-icons">info</i>
                <p>No merge data available</p>
            </div>
        </div>
    </div>

    <div class="section-actions" *ngIf="!noRecordSelected && isExpanded">
        <app-action-row selectedTab="Merge" [data]="masterInfo" [activeAdd]="true" [activeRemove]="true" [activeChange]="true"></app-action-row>
    </div>
</div>
